// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VR-4","type":"styles_type__FHDXK","choices":"styles_choices__3NhTb"};